import React, { useEffect, useRef } from 'react';

const MouseLightEffect = ({ children }) => {
    const lightRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        const light = lightRef.current;

        const handleMouseMove = (e) => {
            const rect = container.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            
            // Aseguramos que la luz se mantenga dentro del contenedor
            const boundedX = Math.min(Math.max(x, 0), rect.width);
            const boundedY = Math.min(Math.max(y, 0), rect.height);
            
            light.style.left = `${boundedX}px`;
            light.style.top = `${boundedY}px`;
        };

        container.addEventListener('mousemove', handleMouseMove);

        return () => {
            container.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    return React.cloneElement(children, {
        ref: containerRef,
        style: {
            ...children.props.style,
            position: 'relative',
            overflow: 'visible'
        },
        children: [
            <div key="mouseLightClip" style={{ position:'absolute', inset:0, overflow:'hidden', borderRadius:'inherit', pointerEvents:'none', zIndex:0 }}>
                <div key="mouseLight" ref={lightRef} className="mouse-light" />
            </div>,
            children.props.children
        ]
    });
};

export default MouseLightEffect;